export default "__VITE_ASSET__bf482b70__"